import React, { Component } from 'react'
import apiService from '../../services/apiservices'
import Select from 'react-select'

class Employees extends Component {
    constructor() {
        super()
        this.state = {
            EmployeesList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getEmployeesListData()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getEmployeesListData = () => {
        apiService.getEmployeesListData()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                    if (listData.status === "SUCCESS") {
                        this.setState({
                            EmployeesList: listData.data ? listData.data : {},
                        })
                    } else {
                        console.error("Filed response from costCenter list api")
                    }
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }

    render() {
        let list = {}
        list = Object.keys(this.state.EmployeesList).map((value,index) => {
            return {
                label : this.state.EmployeesList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));
       

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={list}
                placeholder="Select Department Head"
                onChange={(e) => { (e) ? this.props.employeeChange(e) : this.props.employeeChange([])}}
                />
            </div>
        )
    }
}

export default Employees


// WEBPACK FOOTER //
// ./src/modules/Departments/Components/DropDowns/Employees.js